  import React, { useState, useRef, useEffect } from "react";
  import { useNavigate } from "react-router-dom";
  import "../swipestyles.css";
  import exit from "../images/exit.png";
  import { loremIpsum } from "lorem-ipsum"; // Import lorem ipsum generator
  import solidGreyBackground from "../images/roku.jpg";
  import roku from "../images/roku.jpg";
  import zim from "../images/zim.jpg"; // Import solid grey background image
  import axios from "../api/client";
  import { addFavorite, checkFavorite, createWatchlist, removeFavorite } from "../api/private";
  import FavoriteStar from "./FavStar";
  import ColorThief from 'colorthief';
  import emptys from '../images/Starempty-star.png';
  import TagPills from "./tags";
  import filleds from '../images/Starfilled-star.png';
  import { useUser } from '../context/UserContext';
  import { Info } from 'lucide-react';
    import dayjs from "dayjs";

      import Chart from "react-apexcharts";

function SwipeCompanyLogo({ src, ticker }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src, ticker]);

  if (!src || failed) {
    return (
      <span className="swipeLogoFallback" aria-label={`${ticker || "Company"} logo placeholder`}>
        {String(ticker || "?").charAt(0).toUpperCase()}
      </span>
    );
  }

  return (
    <img
      className="swipeCompanyLogo"
      src={src}
      alt={`${ticker || "Company"} logo`}
      loading="eager"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}




const SWIPE_LOADER_CSS = `
.swipeLoaderOverlay {
  position: absolute;
  inset: 0;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  gap: 76px;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  color: #111827;
  border-radius: inherit;
  pointer-events: none;
}
.swipeLoaderLabel {
  font: 600 13px/1.4 Poppins, system-ui, sans-serif;
  color: #64748b;
  letter-spacing: 0.01em;
}
.loader {
  width: 48px;
  height: 48px;
  margin: 0;
  position: relative;
}
.loader:before {
  content: '';
  width: 48px;
  height: 5px;
  background: #000;
  opacity: 0.25;
  position: absolute;
  top: 60px;
  left: 0;
  border-radius: 50%;
  animation: shadow 0.5s linear infinite;
}
.loader:after {
  content: '';
  width: 100%;
  height: 100%;
  background: #000000;
  animation: bxSpin 0.5s linear infinite;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
}
@keyframes bxSpin {
  17% { border-bottom-right-radius: 3px; }
  25% { transform: translateY(9px) rotate(22.5deg); }
  50% {
    transform: translateY(18px) scale(1, .9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }
  75% { transform: translateY(9px) rotate(67.5deg); }
  100% { transform: translateY(0) rotate(90deg); }
}

.swipeControlButton {
  appearance: none;
  border-radius: 50%;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  transition: background-color 160ms ease, color 160ms ease, transform 160ms ease, box-shadow 160ms ease;
  box-sizing: border-box;
}
.swipeControlButton:hover {
  transform: translateY(-2px) scale(1.04);
}
.swipeControlButton:active {
  transform: translateY(0) scale(0.96);
}
.swipeControlButton--left {
  width: 58px;
  height: 58px;
  border: 3px solid #ff3f72;
  color: #ff5b82;
}
.swipeControlButton--left:hover {
  background: #ff3f72;
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(255, 63, 114, 0.28);
}
.swipeControlButton--favorite {
  width: 72px;
  height: 72px;
  border: 0;
  background: #ffbd2e;
  color: #ffffff;
  box-shadow: 0 8px 22px rgba(255, 189, 46, 0.34);
}
.swipeControlButton--favorite:hover {
  background: #ffca4a;
  box-shadow: 0 10px 26px rgba(255, 189, 46, 0.46);
}
.swipeControlButton--favorite:disabled {
  cursor: wait;
  opacity: 0.65;
}
.swipeControlButton--right {
  width: 58px;
  height: 58px;
  border: 3px solid #00b884;
  color: #13c994;
}
.swipeControlButton--right:hover {
  background: #00b884;
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(0, 184, 132, 0.28);
}
.swipeControlIcon {
  width: 29px;
  height: 29px;
  display: block;
}
.swipeControlIcon--star {
  width: 34px;
  height: 34px;
}
@keyframes shadow {
  0%, 100% { transform: scale(1, 1); }
  50% { transform: scale(1.2, 1); }
}
`;

  const Swiping = () => {
    const getDomain = (url) => { try { return new URL(url).hostname.replace(/^www\./, ""); } catch { return ""; } };
  const truncate = (s = "", len = 200) => (s.length > len ? s.slice(0, len - 1) + "…" : s);

    const overlayRef = useRef(null);
    const card1Ref = useRef(null);
    const card2Ref = useRef(null);
    const [showOverlay, setShowOverlay] = useState(true);
    const [startX, setStartX] = useState(null);
    const { user, isLoggedIn } = useUser();
    const [offsetX, setOffsetX] = useState(0);
    const [wlModalOpen, setWlModalOpen] = useState(false);
const [wlName, setWlName] = useState("Swiping Watchlist");
const [wlSaving, setWlSaving] = useState(false);
const [wlError, setWlError] = useState("");

    const navigate = useNavigate();
    const verticalContentRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentStock, setCurrentStock] = useState(0);
    const numberOfPages = 4;
    const [stockData, setStockData] = useState([]);                // Holds the two “up next” stocks
    const [cache, setCache] = useState({}); 
const queueRequestIdRef = useRef(0);
    // Performance-only caches. These do not change the card UI/dragging behavior;
    // they just avoid refetching logos/details/news/chart data while swiping.
    const detailCacheRef = useRef({});
    const detailsInFlightRef = useRef({});
    const newsRatiosCacheRef = useRef({});
    const chartCacheRef = useRef({});
    const BATCH_PRELOAD_SIZE = 6;
    const [BackupStockData, setBackupStockData] = useState([]);
    const [sector, setSector] = useState("-");
    const [industryA, setIndustry] = useState("-");
    const [Nextsector, setNextSector] = useState("-");
    const [Nextindustry, setNextIndustry] = useState("-");
    const [imageSrc, setImageSrc] = useState("");
    const [nextImageSrc, setNextImageSrc] = useState("");
    const [firstimg, setfirstimg] = useState(false);
    
    const [bio, setBio] = useState("");
    const [nextBio, setNextBio] = useState("");
    const [nextLogo, setNextLogo] = useState("");
    const [logo, setLogo] = useState("");
    const [bioReady, setBioReady] = useState(false);
    const [picks, setPicks] = useState([]);
    const [rightSwipeBurst, setRightSwipeBurst] = useState(0);
    const [nope, setNope] = useState([]);
    const [all, setAll] = useState([]);
    const [ticker, setTicker] = useState('');
    const [hasETF, setHasETF] = useState(false);
    const [nextHasETF, setNextHasETF] = useState(false);
    const [targetSum, setTargetSum] = useState(100); // State to store the target sum
    const [sumOfAmounts, setSumOfAmounts] = useState(0);
    const [isFavorite, setIsFavorite] = useState(false);
    const [favoriteSaving, setFavoriteSaving] = useState(false);
    const [perStock, setPerStock] = useState(0);
    const [bgColor, setBgColor] = useState('#fff');
    const [nextBgColor, setNextBgColor] = useState('#fff');
    const [isCardLoading, setIsCardLoading] = useState(true);
    const [areSettingsOpen, setAreSettingsOpen] = useState(false);
const RATIO_SECTIONS_MIN = ["Ratios", "basicMetrics"]; // where these usually live

const getFromSections = (obj, sectionList, aliasList) => {
  for (const sec of sectionList) {
    const block = obj?.[sec];
    if (!block || typeof block !== "object") continue;
    for (const alias of aliasList) {
      const hit = Object.keys(block).find(
        k => k.toLowerCase().replace(/[^a-z]/g, "") === alias
      );
      if (hit != null) {
        const v = Number(block[hit]);
        if (Number.isFinite(v)) return v;
      }
    }
  }
  return null;
};
const handleExportCsv = () => {
  if (!picks.length) {
    alert("No selected stocks to export yet.");
    return;
  }

  const header = ["Ticker"];

  const rows = picks.map((p) => [p?.stock?.ticker ?? ""]);

  const encodeCell = (val) => {
    const s = String(val ?? "");
    if (/[",\n;]/.test(s)) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };

  const csv =
    [header, ...rows]
      .map((row) => row.map(encodeCell).join(","))
      .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `swiping-tickers-${new Date().toISOString().slice(0,10)}.csv`
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};


const formatNum = (n, d=2) =>
  (n == null || !Number.isFinite(n)) ? "—" : n.toFixed(d);

const formatPercent = (n, d = 1, alreadyPercent = false) => {
  if (n == null || !Number.isFinite(n)) return "—";
  const value = alreadyPercent ? n : n * 100;
  return `${value.toFixed(d)}%`;
};

const formatCompactCurrency = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return new Intl.NumberFormat("en", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(number);
};

const normalizeMetricKey = (key = "") =>
  key.toLowerCase().replace(/[^a-z0-9]/g, "");

const getMetric = (obj, paths = []) => {
  for (const path of paths) {
    const parts = path.split(".");
    let current = obj;

    for (const part of parts) {
      if (!current || typeof current !== "object") {
        current = undefined;
        break;
      }

      const exact = current[part];
      if (exact !== undefined) {
        current = exact;
        continue;
      }

      const normalizedPart = normalizeMetricKey(part);
      const matchedKey = Object.keys(current).find(
        key => normalizeMetricKey(key) === normalizedPart
      );

      current = matchedKey ? current[matchedKey] : undefined;
    }

    const value = Number(current);
    if (Number.isFinite(value)) return value;
  }

  return null;
};

// Aliases normalized to letters only (no spaces/symbols)
const ALIAS = {
  pe: ["pe","pricetoearnings"],
  ps: ["ps","pricetosales"],
  pb: ["pb","pricetobooks"],
  de: ["de","debttoequity"],
};

  // ---- NEW: swipe constants & refs (put near other useState/useRef) ----
  const SWIPE_OUT_PX = 160; // horizontal threshold to trigger dismissal
  const MAX_ROT = 12;       // max rotation degrees
  const FLY_MS = 280;
  const SNAP_MS = 220;

  const dragRef = useRef({
    active: false,
    startX: 0,
    x: 0,
  });
  const buttonSwipeAnimatingRef = useRef(false);
  const celebrateRightSwipe = () => setRightSwipeBurst((burst) => burst + 1);

  const applyTransform = (dx, el) => {
    if (!el) return;
    const rot = Math.max(-MAX_ROT, Math.min(MAX_ROT, dx / 10));
    el.style.transform = `translateX(${dx}px) rotate(${rot}deg)`;
  };

  const clearTransition = (el) => {
    if (!el) return;
    el.style.transition = '';
  };

  const setTransition = (el, ms) => {
    if (!el) return;
    el.style.transition = `transform ${ms}ms cubic-bezier(.22,.61,.36,1)`;
  };

  // ---- NEW: pointer handlers ----
  const onPointerDown = (e) => {
    const el = card1Ref.current;
    if (!el) return;
    el.setPointerCapture?.(e.pointerId);
    el.classList.remove('animating');
    clearTransition(el);

    dragRef.current.active = true;
    dragRef.current.startX = e.clientX ?? (e.touches?.[0]?.clientX || 0);
    dragRef.current.x = 0;
  };

  const onPointerMove = (e) => {
    if (!dragRef.current.active) return;
    const el = card1Ref.current;
    if (!el) return;

    const clientX = e.clientX ?? (e.touches?.[0]?.clientX || 0);
    const dx = clientX - dragRef.current.startX;
    dragRef.current.x = dx;

    // live transform, no transition
    applyTransform(dx, el);
  };

  const onPointerUp = () => {
    if (!dragRef.current.active) return;
    const el = card1Ref.current;
    dragRef.current.active = false;

    const dx = dragRef.current.x;
    const shouldFly = Math.abs(dx) > SWIPE_OUT_PX;
    const direction = Math.sign(dx) || 1;

    if (shouldFly) {
      // fly out
      const off =
        direction *
        (window.innerWidth /* conservative: fly far enough */);
      setTransition(el, FLY_MS);
      el.classList.add('animating');
      applyTransform(off, el);

      const handleEnd = () => {
        el.removeEventListener('transitionend', handleEnd);

        // 1) advance the deck
        setCurrentStock((s) => s + 1);

        // 2) instantly reset position off-screen opposite side, then snap to 0
        clearTransition(el);
        applyTransform(-direction * 40, el);

        // ensure layout tick before snapping back
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTransition(el, SNAP_MS);
            el.classList.remove('animating');
            applyTransform(0, el);

            const cleanup = () => {
              el.removeEventListener('transitionend', cleanup);
              clearTransition(el);
            };
            el.addEventListener('transitionend', cleanup, { once: true });
          });
        });
      };

      el.addEventListener('transitionend', handleEnd, { once: true });
    } else {
      // snap back
      setTransition(el, SNAP_MS);
      applyTransform(0, el);
      const cleanup = () => {
        el.removeEventListener('transitionend', cleanup);
        clearTransition(el);
      };
      el.addEventListener('transitionend', cleanup, { once: true });
    }
  };





























  function darkenColor(color, amount = 0.1) {
    // Works for hex (#RRGGBB) or rgb(r,g,b)
    let r, g, b;

    if (color.startsWith("#")) {
      const bigint = parseInt(color.slice(1), 16);
      r = (bigint >> 16) & 255;
      g = (bigint >> 8) & 255;
      b = bigint & 255;
    } else if (color.startsWith("rgb")) {
      [r, g, b] = color.match(/\d+/g).map(Number);
    } else {
      // fallback if invalid
      return color;
    }

    r = Math.max(0, Math.min(255, r * (1 - amount)));
    g = Math.max(0, Math.min(255, g * (1 - amount)));
    b = Math.max(0, Math.min(255, b * (1 - amount)));

    return `rgb(${r}, ${g}, ${b})`;
  }

    //NjBEzizi0Mf7ZKBzsvNxvV6-7mtY1sD_OUY37BSBmvk
    const unsplashAccessKey = "NjBEzizi0Mf7ZKBzsvNxvV6-7mtY1sD_OUY37BSBmvk";
  function useWindowDimensions() {
        const [windowDimensions, setWindowDimensions] = useState({
          width: window.innerWidth,
          height: (window.innerHeight - 64 - 185 - 12 - 33 - 80)
        });
      
        useEffect(() => {
          function handleResize() {
          

              setWindowDimensions({
                width: window.innerWidth,
                height: (window.innerHeight - 64 - 185 - 12 - 33 - 80 )
              });
            
          }
      
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);
      
        return windowDimensions;
      }
    const handleCloseOverlay = () => {
      setShowOverlay(false);
      navigate(-1); // Navigate back to the previous route
    };
    const extractColor = (imgEl, setBg, setText, ref, onReady) => {
      let readyCalled = false;
      const finish = () => {
        if (readyCalled) return;
        readyCalled = true;
        onReady?.();
      };
      const fallbackTimer = setTimeout(() => {
        setBg('#f3f4f6');
        setText('#111827');
        finish();
      }, 5000);
      const finishAndClearTimer = () => {
        clearTimeout(fallbackTimer);
        finish();
      };
      try {
        const colorThief = new ColorThief();
        const applyColor = () => {
          try {
            const [r, g, b] = colorThief.getColor(imgEl);
            const rgbStr = `rgb(${r}, ${g}, ${b})`;
            setBg(rgbStr);
            const contrast = getContrastColor([r, g, b]);
            setText(contrast);
            // apply with !important
            if (ref.current) {
              ref.current.style.setProperty('background-color', rgbStr, 'important');
              ref.current.style.setProperty('color', contrast, 'important');
            }
          } catch (e) {
            console.error('Color extraction failed', e);
            setBg('#f3f4f6');
            setText('#111827');
          } finally {
            finishAndClearTimer();
          }
        };
        if (imgEl.complete) {
          applyColor();
        } else {
          imgEl.addEventListener('load', applyColor, { once: true });
          imgEl.addEventListener('error', () => {
            setBg('#f3f4f6');
            setText('#111827');
            finishAndClearTimer();
          }, { once: true });
        }
      } catch (e) {
        console.error('Color extraction failed', e);
        setBg('#f3f4f6');
        setText('#111827');
        finishAndClearTimer();
      }
    };
    useEffect(() => {
      if (!logo) {
        setBgColor('#f3f4f6');
        setTextColor('#111827');
        setIsCardLoading(false);
        return;
      }

      setIsCardLoading(true);
      const img1 = new Image();
      img1.crossOrigin = 'Anonymous';
      img1.src = logo;
      extractColor(img1, setBgColor, setTextColor, card1Ref, () => setIsCardLoading(false));
    }, [logo]);

    useEffect(() => {
      if (!nextLogo) {
        setNextBgColor('#f3f4f6');
        setNextTextColor('#111827');
        return;
      }

      const img2 = new Image();
      img2.crossOrigin = 'Anonymous';
      img2.src = nextLogo;
      extractColor(img2, setNextBgColor, setNextTextColor, card2Ref);
    }, [nextLogo]);

    useEffect(() => {
      let cancelled = false;

      const checkIfFavorite = async () => {
        if (!isLoggedIn || !ticker) {
          setIsFavorite(false);
          return;
        }

        try {
          const response = await checkFavorite(ticker);

          if (!cancelled) {
            setIsFavorite(Boolean(response.data?.isFavorite));
          }
        } catch (error) {
          if (!cancelled) {
            setIsFavorite(false);
          }
          console.error("Failed to check if ticker is in favorites", error);
        }
      };

      checkIfFavorite();

      return () => {
        cancelled = true;
      };
    }, [isLoggedIn, ticker]);

    const toggleFavorite = async () => {
      if (favoriteSaving || !ticker || !isLoggedIn) return;

      const nextFavorite = !isFavorite;
      setIsFavorite(nextFavorite);
      setFavoriteSaving(true);

      try {
        await (nextFavorite ? addFavorite(ticker) : removeFavorite(ticker));

        // Also feed favorites into the swiping recommendation profile.
        logSwipingAction({
          ticker,
          action: nextFavorite ? "favorite_add" : "favorite_remove",
        });
      } catch (error) {
        setIsFavorite(!nextFavorite);
        console.error("Failed to toggle favorite", error);
      } finally {
        setFavoriteSaving(false);
      }
    };
const handleCreateWatchlistSubmit = async (e) => {
  e.preventDefault();

  const name = String(wlName || "").trim();

  if (!name) {
    setWlError("Please enter a watchlist name.");
    return;
  }

  if (!user?.displayname) {
    setWlError("You need to be logged in to create a watchlist.");
    return;
  }

  const components = Array.from(
    new Set(
      picks
        .map((pick) => pick?.stock?.ticker)
        .filter(Boolean)
        .map((symbol) => String(symbol).trim().toUpperCase())
        .filter(Boolean)
    )
  );

  try {
    setWlSaving(true);
    setWlError("");

    const response = await createWatchlist(name, components);

    if (!response?.data?.watchlists) {
      throw new Error("The server did not return the updated watchlists.");
    }

    setWlModalOpen(false);
    setWlName("Swiping Watchlist");
  } catch (err) {
    console.error("Failed to create watchlist", err);
    setWlError(
      err?.response?.data?.message ||
        "Could not create watchlist. Please try again."
    );
  } finally {
    setWlSaving(false);
  }
};



    const getLuminance = ([r, g, b]) => {
      const a = [r, g, b].map((v) => {
        const f = v / 255;
        return f <= 0.03928 ? f / 12.92 : Math.pow((f + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    };

      const getContrastColor = ([r, g, b]) => {
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      // if bright background, use dark text; otherwise white
      return brightness > 128 ? '#000000' : '#ffffff';
    };

    const [textColor, setTextColor] = useState('#000000');

    const [nextTextColor, setNextTextColor] = useState('#000000');
    useEffect(() => {
      // Calculate the sum of amounts whenever it changes
      const sum = picks.reduce((total, pick) => total + pick.amount.perStock, 0);
      setSumOfAmounts(sum);
      
    }, [picks]);
    const handleMouseDown = (event) => {
      setStartX(event.clientX);
    };
    const [activeStock, setActiveStock] = useState("");
    const [cap, setCap] = useState(0);
  const [nextCap, setNextCap] = useState(0);
  const [currentRatios, setCurrentRatios] = useState({});
  const [nextRatios, setNextRatios] = useState({});
  const [currentNews, setCurrentNews] = useState([]);
  const [nextNews, setNextNews] = useState([]);


  const getRatiosAndNews = async (ticker) => {
    if (!ticker) return { ratios: {}, news: [] };

    if (newsRatiosCacheRef.current[ticker]) {
      return newsRatiosCacheRef.current[ticker];
    }

    const [ratiosRes, newsRes] = await Promise.all([
      axios.get(`https://stocksleuth.xyz:5000/GetRatiosAndAllThat?ticker=${encodeURIComponent(ticker)}`),
      axios.get(`https://stocksleuth.xyz:5000/news/${encodeURIComponent(ticker)}`),
    ]);

    const ratios = ratiosRes?.data ?? {};

    // Try a few common shapes for news payload
    const newsRaw = newsRes?.data;
    const news =
      Array.isArray(newsRaw) ? newsRaw :
      Array.isArray(newsRaw?.items) ? newsRaw.items :
      Array.isArray(newsRaw?.news) ? newsRaw.news :
      [];

    const result = { ratios, news };
    newsRatiosCacheRef.current[ticker] = result;
    return result;
  };

    //useEffect(() => {}, []);




const [universe, setUniverse] = useState([]); // now filled by /swiping/queue
const [queueMeta, setQueueMeta] = useState({
  algorithm: "cold_start_diversified_v1",
  personalizationReady: false,
  actionCount: 0,
});
const [queueLoading, setQueueLoading] = useState(false);

const API_BASE = "https://stocksleuth.xyz:5000";
const SWIPING_QUEUE_LIMIT = 30;
const QUEUE_REFILL_AT = 8;
const displayName = user?.displayname || null;
const sessionIdRef = useRef(
  `swp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
);
const queueRequestInFlightRef = useRef(false);
const currentAlgorithmRef = useRef("cold_start_diversified_v1");
const cardStartedAtRef = useRef(Date.now());
const pagesViewedRef = useRef(new Set([0]));

const normalizeSymbol = (value) => String(value || "").trim().toUpperCase();

const appendUniqueStocks = (oldStocks, newStocks) => {
  const seen = new Set(oldStocks.map((s) => normalizeSymbol(s.symbol)));
  const merged = [...oldStocks];

  for (const stock of newStocks || []) {
    const symbol = normalizeSymbol(stock?.symbol);
    if (!symbol || seen.has(symbol)) continue;
    seen.add(symbol);
    merged.push(stock);
  }

  return merged;
};

const loadSwipingQueue = async ({ append = false } = {}) => {
  if (queueRequestInFlightRef.current && append) return;

  const requestId = ++queueRequestIdRef.current;
  const effectiveDisplayName = user?.displayname;

  if (!effectiveDisplayName) return;

  try {
    queueRequestInFlightRef.current = true;
    setQueueLoading(true);

    const response = await axios.get(`${API_BASE}/swiping/queue`, { params: { limit: SWIPING_QUEUE_LIMIT } });

    // If another newer queue request finished/started after this one, ignore this response.
    if (requestId !== queueRequestIdRef.current) return;

    const data = response.data || {};
    const stocks = Array.isArray(data.stocks) ? data.stocks : [];


    currentAlgorithmRef.current = data.algorithm || currentAlgorithmRef.current;

    setQueueMeta({
      algorithm: data.algorithm || "unknown",
      personalizationReady: Boolean(data.personalizationReady),
      actionCount: Number(data.actionCount || 0),
    });

    setUniverse((prev) => {
      if (!append) return appendUniqueStocks([], stocks);
      return appendUniqueStocks(prev, stocks);
    });
  } catch (error) {
    if (requestId !== queueRequestIdRef.current) return;

    console.error("Failed to load swiping queue:", error);

    if (!append) {
      try {
        const fallback = await axios.get(`${API_BASE}/stockswhighPriority`);

        if (requestId !== queueRequestIdRef.current) return;

        const list = Array.isArray(fallback.data) ? fallback.data : [];
        setUniverse(list.sort(() => Math.random() - 0.5));
        setQueueMeta({
          algorithm: "fallback_stockswhighPriority_random",
          personalizationReady: false,
          actionCount: 0,
        });
      } catch (fallbackError) {
        console.error("Fallback swiping universe failed:", fallbackError);
      }
    }
  } finally {
    if (requestId === queueRequestIdRef.current) {
      queueRequestInFlightRef.current = false;
      setQueueLoading(false);
    }
  }
};
const logSwipingAction = async ({ ticker: actionTicker, action }) => {
  const cleanTicker = normalizeSymbol(actionTicker);
  if (!cleanTicker || !action) return;

  const dwellMs = Math.max(0, Date.now() - cardStartedAtRef.current);
  const pagesViewed = Array.from(pagesViewedRef.current || []);

  try {
    await axios.post(`${API_BASE}/swiping/action`, {
      sessionId: sessionIdRef.current,
      ticker: cleanTicker,
      action,
      dwellMs,
      lastPage: currentPage,
      pagesViewed,
      algorithm: currentAlgorithmRef.current,
    });
  } catch (error) {
    // Do not block swiping if analytics/recommendation logging fails.
    console.error("Failed to log swiping action:", error);
  }
};

useEffect(() => {
  // Do not request anonymous queue while auth/user is still resolving.
  if (!displayName) return;

  queueRequestIdRef.current += 1;

  setUniverse([]);
  setCurrentStock(0);
  setStockData([]);

  detailCacheRef.current = {};
  newsRatiosCacheRef.current = {};
  chartCacheRef.current = {};

  currentAlgorithmRef.current = "cold_start_diversified_v1";
  sessionIdRef.current = `swp_${Date.now()}_${Math.random()
    .toString(36)
    .slice(2, 10)}`;

  loadSwipingQueue({ append: false });
}, [displayName]);

useEffect(() => {
  if (!universe.length) return;

  const remaining = universe.length - currentStock;
  if (remaining <= QUEUE_REFILL_AT) {
    loadSwipingQueue({ append: true });
  }
}, [currentStock, universe.length]);

useEffect(() => {
  pagesViewedRef.current.add(currentPage);
}, [currentPage]);

useEffect(() => {
  if (!ticker) return;
  cardStartedAtRef.current = Date.now();
  pagesViewedRef.current = new Set([0]);
}, [ticker]);





    const preloadLogoImage = (src) => {
      if (!src) return;
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = src;
    };

    const logoFromDetailData = (detailData) => {
      if (!detailData?.logo?.data) return "";

      try {
        const buf = new Uint8Array(detailData.logo.data);
        let binary = "";
        const chunkSize = 0x8000;

        for (let i = 0; i < buf.length; i += chunkSize) {
          binary += String.fromCharCode.apply(null, buf.subarray(i, i + chunkSize));
        }

        return `data:image/png;base64,${btoa(binary)}`;
      } catch (error) {
        console.error("Logo conversion failed:", error);
        return "";
      }
    };

    const fetchDetail = async (stock) => {
      const symbol = stock?.symbol;
      if (!symbol) return { sector: "", industry: "", hasETF: false, logo: "", bio: "" };

      if (detailCacheRef.current[symbol]) {
        return detailCacheRef.current[symbol];
      }

      if (detailsInFlightRef.current[symbol]) {
        return detailsInFlightRef.current[symbol];
      }

      const request = (async () => {
        const searchUrl = `https://stocksleuth.xyz:5000/call?url=${encodeURIComponent(
          `https://query1.finance.yahoo.com/v1/finance/search?q=${symbol}`
        )}`;

        const [searchResult, detailResult] = await Promise.allSettled([
          axios.get(searchUrl, { timeout: 10000 }),
          axios.get(`https://stocksleuth.xyz:5000/auth/getstockdetails?symbol=${symbol}`, { timeout: 10000 }),
        ]);

        const searchData = searchResult.status === "fulfilled" ? searchResult.value.data : {};
        const detailData = detailResult.status === "fulfilled" ? detailResult.value.data : {};

        const quote = (searchData.quotes && searchData.quotes[0]) || {};
        const logo = logoFromDetailData(detailData);

        preloadLogoImage(logo);

        const result = {
          // Prefer backend queue data so the algo/card stays consistent;
          // Yahoo search is just a fallback for missing fields.
          sector: stock.sector || quote.sector || "",
          industry: stock.industry || quote.industry || "",
          hasETF: Boolean(stock.ETF) || quote.quoteType === "ETF",
          logo,
          bio: stock.Description || "",
        };

        detailCacheRef.current[symbol] = result;
        return result;
      })();

      detailsInFlightRef.current[symbol] = request;

      try {
        return await request;
      } finally {
        delete detailsInFlightRef.current[symbol];
      }
    };

    useEffect(() => {
      if (!universe.length) return;

      let cancelled = false;

      const loadSlice = async () => {
        setIsCardLoading(true);
        const slice = universe.slice(currentStock, currentStock + 2);
        setStockData(slice);
        setCurrentNews([]);
        setCurrentRatios({});

        const [curStock, nextStock] = slice;
        const [curResult, nextResult] = await Promise.allSettled([
          curStock ? fetchDetail(curStock) : Promise.resolve(null),
          nextStock ? fetchDetail(nextStock) : Promise.resolve(null),
        ]);
        const cur = curResult.status === "fulfilled" ? curResult.value : null;
        const nxt = nextResult.status === "fulfilled" ? nextResult.value : null;

        if (curResult.status === "rejected") {
          console.error("Current swipe card details failed:", curResult.reason);
        }
        if (nextResult.status === "rejected") {
          console.error("Next swipe card details failed:", nextResult.reason);
        }

        if (cancelled) return;

        const visibleCache = { ...detailCacheRef.current };
        setCache(visibleCache);

        if (curStock && cur) {
          setTicker(curStock.symbol);
          setActiveStock(curStock.symbol);
          setSector(cur.sector);
          setIndustry(cur.industry);
          setHasETF(cur.hasETF);
          setCap(curStock.marketCap);
          setLogo(cur.logo);
          setBio(cur.bio);

          getRatiosAndNews(curStock.symbol)
            .then((newsAndRatios) => {
              if (cancelled) return;
              setCurrentNews(newsAndRatios.news);
              setCurrentRatios(newsAndRatios.ratios);
            })
            .catch((error) => {
              console.error("Error fetching news and ratios:", error);
            });
        } else if (curStock) {
          // Keep the queue card usable even if optional enrichment failed.
          setTicker(curStock.symbol);
          setActiveStock(curStock.symbol);
          setSector(curStock.sector || "-");
          setIndustry(curStock.industry || "-");
          setHasETF(Boolean(curStock.ETF));
          setCap(curStock.marketCap || 0);
          setLogo("");
          setBio(curStock.Description || "");
        }

        if (nextStock && nxt) {
          setNextSector(nxt.sector);
          setNextIndustry(nxt.industry);
          setNextHasETF(nxt.hasETF);
          setNextCap(nextStock.marketCap);
          setNextLogo(nxt.logo);
          setNextBio(nxt.bio);
        } else {
          setNextSector("-");
          setNextIndustry("-");
          setNextHasETF(false);
          setNextCap(0);
          setNextLogo("");
          setNextBio("");
        }

        if (!curStock || !cur) {
          setIsCardLoading(false);
        }

        // Warm the next few logos/details in the background. No UI/dragging changes.
        const preloadBatch = universe.slice(currentStock + 2, currentStock + BATCH_PRELOAD_SIZE);
        preloadBatch.forEach((stock) => {
          fetchDetail(stock).catch(() => {});
        });

        // News/ratios are heavier, so only warm one upcoming card.
        if (nextStock?.symbol) {
          getRatiosAndNews(nextStock.symbol).catch(() => {});
        }

        // Card data is usable even when a logo is absent or its color extraction
        // does not trigger a new React effect (for example "" -> "").
        if (!cancelled) setIsCardLoading(false);
      };

      loadSlice().catch((error) => {
        console.error("Swipe card loading failed:", error);
        if (!cancelled) setIsCardLoading(false);
      });

      return () => {
        cancelled = true;
      };
    }, [currentStock, universe]);



    function randomTagBg() {
      const h = Math.floor(Math.random() * 360);
      const s = 60 + Math.random() * 20;  // 60–80% saturation
      const l = 40 + Math.random() * 20;  // 40–60% lightness
      return `hsl(${h},${s.toFixed(0)}%,${l.toFixed(0)}%)`;
    }
    
    // 1b) contrast checker (brightness formula)



    const handleMouseMove = (event) => {
      if (startX !== null) {
        const newOffsetX = event.clientX - startX;
        //console.log(newOffsetX);
        setOffsetX(newOffsetX);
        const maxRotation = 10; // Maximum rotation angle in degrees
        const rotationFactor = newOffsetX / 10; // Adjust rotation based on offsetX
        const rotation =
          Math.min(Math.abs(rotationFactor), maxRotation) *
          Math.sign(rotationFactor);

        if (card1Ref.current) {
          card1Ref.current.style.transition = "none"; // Disable transition during drag
          card1Ref.current.style.transform = `translateX(${newOffsetX}px) rotate(${rotation}deg)`;
        } else {
          console.log("F?");
        }
      }
      if (sumOfAmounts >= targetSum) {
        alert(`Sum of amounts has reached ${targetSum}`);
      }
    };
    useEffect(() => {
      console.log(currentPage);
    }, [currentPage]);
const handleMouseUp = () => {
  const currentTicker = stockData[0]?.symbol || activeStock;
  const didSwipe = Math.abs(offsetX) > 100;

  if (didSwipe && currentTicker) {
    const action = offsetX > 0 ? "swipe_right" : "swipe_left";

    if (offsetX > 0) {
      console.log("Swiped right");
      celebrateRightSwipe();
      setPicks(prev => [
        ...prev,
        {
          stock: { ticker: currentTicker },
          amount: { perStock },
        },
      ]);
    } else {
      console.log("Swiped left");
      setNope(prev => [...prev, { stock: { ticker: currentTicker } }]);
    }

    setAll(prev => [...prev, { stock: { ticker: currentTicker } }]);

    // Fire and forget: don't block the swipe animation/UI if logging fails.
    logSwipingAction({
      ticker: currentTicker,
      action,
    });

    // 👇 capture current "next" colors so they don't change under us
    const newBg = nextBgColor;
    const newText = nextTextColor;

    // let the card snap back first (same as 0.3s transform)
    setTimeout(() => {
      setBgColor(newBg);
      setTextColor(newText);
    }, 300); // ~ same as "go back" duration

    setCurrentStock(prev => prev + 1);

    setImageSrc(nextImageSrc);
    setBio(nextBio);
    fisrtPage();
  }

  setStartX(null);
  setOffsetX(0);

  if (card1Ref.current) {
    card1Ref.current.style.transition = "transform 0.3s ease";
    card1Ref.current.style.transform = "translateX(0) rotate(0)";
  }
};

const handleSwipeButton = (direction) => {
  const currentTicker = stockData[0]?.symbol || activeStock;
  const card = card1Ref.current;
  if (!currentTicker || !card || buttonSwipeAnimatingRef.current) return;

  const isRight = direction === "right";
  const directionMultiplier = isRight ? 1 : -1;
  const flyDistance = Math.max(window.innerWidth, 900) * directionMultiplier;

  buttonSwipeAnimatingRef.current = true;
  if (isRight) celebrateRightSwipe();
  card.style.transition = `transform ${FLY_MS}ms cubic-bezier(.22,.61,.36,1)`;
  card.style.transform = `translateX(${flyDistance}px) rotate(${directionMultiplier * MAX_ROT}deg)`;

  window.setTimeout(() => {
    if (isRight) {
      setPicks(prev => [
        ...prev,
        {
          stock: { ticker: currentTicker },
          amount: { perStock },
        },
      ]);
    } else {
      setNope(prev => [...prev, { stock: { ticker: currentTicker } }]);
    }

    setAll(prev => [...prev, { stock: { ticker: currentTicker } }]);
    logSwipingAction({
      ticker: currentTicker,
      action: isRight ? "swipe_right" : "swipe_left",
    });

    setBgColor(nextBgColor);
    setTextColor(nextTextColor);
    setCurrentStock(prev => prev + 1);
    setImageSrc(nextImageSrc);
    setBio(nextBio);
    fisrtPage();
    setStartX(null);
    setOffsetX(0);

    card.style.transition = "none";
    card.style.transform = `translateX(${-directionMultiplier * 45}px) rotate(${-directionMultiplier * 2}deg)`;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        card.style.transition = `transform ${SNAP_MS}ms cubic-bezier(.22,.61,.36,1)`;
        card.style.transform = "translateX(0) rotate(0)";

        window.setTimeout(() => {
          card.style.transition = "";
          buttonSwipeAnimatingRef.current = false;
        }, SNAP_MS);
      });
    });
  }, FLY_MS);
};


    //useEffect(() => {console.log(offsetX);});
    useEffect(() => {
      //console.log(offsetX);

      const updateRotation = () => {
        // Calculate rotation based on offsetX
        const maxRotation = 10; // Maximum rotation angle in degrees
        const rotationFactor = offsetX / 10; // Adjust rotation based on offsetX
        const rotation =
          Math.min(Math.abs(rotationFactor), maxRotation) *
          Math.sign(rotationFactor);

        // Apply rotation to the element
        if (card1Ref.current && !buttonSwipeAnimatingRef.current) {
          card1Ref.current.style.transition = "transform 0.7s ease"; // Disable transition during drag
          card1Ref.current.style.transform = `translateX(${offsetX}px) rotate(${rotation}deg)`;
        }

        // Continue updating rotation
        requestAnimationFrame(updateRotation);
      };

      // Start updating rotation
      updateRotation();

      document.addEventListener("mousemove", handleMouseMove); // Attach mousemove event listener to document
      return () => {
        document.removeEventListener("mousemove", handleMouseMove); // Clean up event listener on component unmount
      };
    });
    const handleLeft = () => {
      setCurrentPage((prevPage) =>
        prevPage === 0 ? numberOfPages - 1 : prevPage - 1
      ); // If on the first page, go to the last page; otherwise, decrement by 1
    };
    const fisrtPage = () => {
      setTimeout(() => {
        setCurrentPage(0);
        console.log("Current page reset to 0:", currentPage); // Log after resetting currentPage
      }, 50);
    };
    const handleRight = () => {
      setCurrentPage((prevPage) =>
        prevPage === numberOfPages - 1 ? 0 : prevPage + 1
      ); // If on the last page, go to the first page; otherwise, increment by 1
    };

  const [chartData, setChartData] = useState(null);
      const [chartError, setChartError] = useState(false);
      const [sma50Enabled, setSma50Enabled] = useState(false);
      const [sma100Enabled, setSma100Enabled] = useState(false);
      const [sma200Enabled, setSma200Enabled] = useState(false);
      const [interval, setInter2val] = useState("1d");
      const [lastChart, setLastChart] = useState("price");
      const [isBSmultiplierLoaded, setIsBSmultiplierLoaded] = useState(false);
      const [range, setRange] = useState("YTD");
      
      const [currentPrice, setCurrentPrice] = useState(null); // New state for current price
      const [prevPrice, setPrevPrice] = useState(null);
      const [showCandlestick, setShowCandlestick] = useState(true);
        const ranges = ["YTD", "1Y", "5Y", "MAX"];

      const [logoInfo, setLogoInfo] = useState(null);
      const [nameInfo, setnameInfo] = useState(null);
      const [messages, setMessages] = useState([]); // State for chat messages
      const [newMessage, setNewMessage] = useState("");
      const [messagStats, setMesageStats] = useState(1);
      const [fetchingOlderMessages, setFetchingOlderMessages] = useState(false);
      const chatBoxRef = useRef(null);
      const [balanceSheetData, setBalanceSheetData] = useState(null);
      const [AllHistData, setAllHistData] = useState([]);
      const [showPopup, setShowPopup] = useState(false);
      const [activeStatement, setActiveStatement] = useState("balanceSheet");
      const [cfData, setcfData] = useState(null);
      const [BSmultiplier, setBSmultiplier] = useState(1000);
      const [ISmultiplier, setISmultiplier] = useState(1000);
      const [activeData, setActiveData] = useState("Summary");
      const [isChart, setIsChart] = useState(1);
      const [isQuarterly, setIsQuarterly] = useState(1);
      const [hoveredRow, setHoveredRow] = useState(null);
      const [mostRecentQ, setMostRecentQ] = useState("");
      const [QData, setQdata] = useState([]);
      const [FYData, setFYdata] = useState([]);
      const [description, setDescription] = useState("");
      const [ratios, setRatios] = useState(null);
      const [lastFYdate, setlastFy] = useState(null);
      const [periodlow, set52weeklow] = useState(0);
      const [periodhigh, set52weekhigh] = useState(0);
      const [periodChange, setPeriodChange] = useState(0);
      const [logoim, setLogoimg] = useState(null);
      const [FinishedLoading, setFinishedLoading] = useState(false);
      const { width, height } = useWindowDimensions();
      const chartContainerRef = useRef(null);
      const [chartType, setChartType] = useState("candlestick");
      const [showVolume, setShowVolume] = useState(true);  
  const [isThinking, setIsThinking] = useState(false);

  const makeChartData = (data, textColorForChart) => {
          const closePrices = data.indicators.quote[0].close;
          const lastIndex = closePrices.length - 1;
          const periodChange =
            ((closePrices[lastIndex] - closePrices[0]) / closePrices[0]) * 100;

          const quote = data.indicators.quote[0];

const validLows = quote.low
  .map(Number)
  .filter((value) => Number.isFinite(value) && value >= 0);

const validHighs = quote.high
  .map(Number)
  .filter((value) => Number.isFinite(value) && value >= 0);

const validCloses = quote.close
  .map(Number)
  .filter((value) => Number.isFinite(value) && value >= 0);

const minLow = validLows.length
  ? Math.min(...validLows)
  : Math.min(...validCloses);

const maxHigh = validHighs.length
  ? Math.max(...validHighs)
  : Math.max(...validCloses);

const priceRange = Math.max(maxHigh - minLow, 0);
const pad = Math.max(priceRange * 0.05, maxHigh * 0.005, 0.01);

const yAxisMin = Math.max(0, minLow - pad);
const yAxisMax = maxHigh + pad;

          return {
            periodChange,
            chart: {
              series: [
                !showCandlestick && {
                  name: "candle",
                  type: "candlestick",
                  data: data.timestamp.map((timestamp, index) => ({
                    x: new Date(timestamp * 1000),
                    y: [
                      data.indicators.quote[0].open[index],
                      data.indicators.quote[0].high[index],
                      data.indicators.quote[0].low[index],
                      data.indicators.quote[0].close[index],
                    ],
                  })),
                },
                showCandlestick && {
                  name: "close",
                  type: "line",
                  data: data.indicators.quote[0].close.map((value, index) => ({
                    x: new Date(data.timestamp[index] * 1000),
                    y: value,
                  })),
                },
              ].filter(Boolean),
              options: {
                plotOptions: {
                  candlestick: {
                    colors: {
                      upward: "#2cd42c",
                      downward: "#ff5733",
                    },
                  },
                },
                stroke: {
                  width: [2],
                  colors: [textColorForChart],
                },
                legend: {
                  show: false,
                },
                tooltip: {
                  marker: {
                    show: false,
                  },
                  onDatasetHover: {
                    highlightDataSeries: false,
                  },
                  followCursor: false,
                  intersect: false,
                  custom: function () {
                    return "";
                  },
                },
                chart: {
                  type: showCandlestick ? "candlestick" : "line",
                  toolbar: {
                    autoSelected: "none",
                    show: false,
                  },
                },
                states: {
                  normal: {
                    filter: {
                      type: "none",
                      value: 0,
                    },
                  },
                  hover: {
                    filter: {
                      type: "none",
                      value: 0,
                    },
                  },
                },
                grid: {
                  position: "back",
                  borderColor: "#FDFBFF",
                  show: false,
                },
                xaxis: {
                  axisBorder: { show: false },
                  type: "category",
                  show: false,
                  tickAmount: 4,
                  axisTicks: {
                    show: false,
                  },
                  labels: {
                    show: false,
                    style: {
                      cssClass: "RemoveFirstDate",
                    },
                    formatter: function (val) {
                      if (range === "1d") {
                        return dayjs(val).format("HH:mm");
                      } else if (["5d", "1mo", "3mo", "6mo"].includes(range)) {
                        return dayjs(val).format("DD.MM");
                      } else if (["1y", "2y", "5y", "ytd", "max"].includes(range)) {
                        return dayjs(val).format("MMM YYYY");
                      }

                      return dayjs(val).format("MMM YY");
                    },
                    rotate: 0,
                  },
                  crosshairs: {
                    show: false,
                  },
                  tooltip: {
                    enabled: false,
                  },
                },
                yaxis: {
                  min: yAxisMin,
                  max: yAxisMax,
                  tickAmount: 1,
                  forceNiceScale: false,
                  decimalsInFloat: 2,
                  labels: {
                    show: true,
                    formatter: (val) => val.toFixed(2),
                    style: {
                      colors: [textColorForChart],
                      fontSize: "16px",
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    },
                  },
                  opposite: true,
                  axisBorder: { show: false },
                  axisTicks: { show: false },
                  tooltip: { enabled: false },
                  crosshairs: { show: false },
                },
                markers: {
                  size: 0,
                },
              },
            },
          };
        };

  useEffect(() => {
        if (!ticker || currentPage !== 1) return;

        let cancelled = false;
        const fetchStockData = async () => {
          try {
            const cacheKey = `${ticker}|${interval}|${range}|${showCandlestick}|${textColor}`;
            const cached = chartCacheRef.current[cacheKey];

            if (cached) {
              setChartError(false);
              setPeriodChange(cached.periodChange);
              setChartData(cached.chart);
              return;
            }

            setChartData(null);
            setChartError(false);
            const proxyUrl = "https://stocksleuth.xyz:5000/call?url=";
            const apiUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${ticker}?metrics=high?&interval=${interval}&range=${range.toLocaleLowerCase()}`;
            const encodedApiUrl = encodeURIComponent(apiUrl);
            const response = await axios.get(proxyUrl + encodedApiUrl);
            const data = response.data.chart.result[0];
            const built = makeChartData(data, textColor);

            chartCacheRef.current[cacheKey] = built;

            if (cancelled) return;
            setPeriodChange(built.periodChange);
            setChartData(built.chart);
          } catch (error) {
            console.error(error);
            if (!cancelled) setChartError(true);
          }
        };

        fetchStockData();

        return () => {
          cancelled = true;
        };
      }, [ticker, range, interval, showCandlestick, textColor, currentPage]);
  const GearIcon = ({
    width = "22px",
    height = "22px",
    fill = "black ",
    ...props
  }) => (
    <svg
      fill={fill}
      width={width}
      height={height}
      viewBox="0 0 54 54"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z" />
      <path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z" />
    </svg>
  );


    const hasActiveCard = stockData.length > 0 && !isCardLoading && !queueLoading;

    return (
    
        <div
          className="overlay Background"
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          ref={overlayRef}
        >
          <style>{SWIPE_LOADER_CSS}</style>
          {rightSwipeBurst > 0 && (
            <div key={rightSwipeBurst} className="swipeSparkBurst" aria-hidden="true">
              {Array.from({ length: 12 }, (_, index) => <span key={index} />)}
              <strong>Discovered</strong>
            </div>
          )}

          <button type="button" aria-label="How swiping works" title="How swiping works" onClick={() => {setAreSettingsOpen(!areSettingsOpen)}} className='bell swipeInfoButton' style={{ position: "absolute", top: "20px", right: "20px" }} onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,.12)")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0)")}>
  <Info size={22} strokeWidth={2} aria-hidden="true" />
          
            </button>  {areSettingsOpen && (
  <div
    className="settingsPanel"
    style={{
      width: "50%",
      position: "absolute",
      alignSelf: "center",
      zIndex: 100000,
      backgroundColor: "rgb(255, 255, 255)",
      color: "rgba(0, 0, 0, 1)",
      borderRadius: "14px",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
      padding: "18px",
      height: "auto",
      maxHeight: "64vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      fontFamily: "Poppins",
      overflowY: "auto",
    }}
  >
    <h3 style={{ margin: "0 0 10px", fontSize: 18 }}>
      How swiping works
    </h3>

    <p
      style={{
        margin: "0 0 12px",
        fontSize: 13,
        lineHeight: 1.55,
        color: "#374151",
        textAlign: "left",
      }}
    >
      Swiping is a quick discovery tool for exploring stocks. Swipe right when a
      company looks interesting, swipe left when it does not. Your selected stocks
      are saved in this session so you can later create a watchlist or export them.
    </p>

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        width: "100%",
      }}
    >
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 3, textAlign: "left" }}>
          What affects the queue?
        </div>
        <div style={{ fontSize: 12, lineHeight: 1.5, color: "#4b5563", textAlign: "left"  }}>
          The queue starts with a diversified set of companies. As you swipe,
          StockSleuth can use signals like right swipes, left swipes, favorites,
          pages viewed, and time spent on cards to make future suggestions more
          relevant.
        </div>
      </div>

      <div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 3, textAlign: "left" }}>
          What a right swipe means
        </div>
        <div style={{ fontSize: 12, lineHeight: 1.5, color: "#4b5563", textAlign: "left"  }}>
          A right swipe means “this is worth looking at again.” It is not a buy
          order, portfolio allocation, or recommendation.
        </div>
      </div>

      <div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 3, textAlign: "left" }}>
          What this is not
        </div>
        <div style={{ fontSize: 12, lineHeight: 1.5, color: "#4b5563", textAlign: "left"  }}>
          Swiping is not financial advice, investment advice, or a recommendation
          to buy, sell, or hold any security. The cards are meant for discovery
          and research only. Always do your own analysis before making investment
          decisions.
        </div>
      </div>
    </div>

    <button
      type="button"
      onClick={() => setAreSettingsOpen(false)}
      style={{
        alignSelf: "flex-end",
        marginTop: 16,
        border: "none",
        background: "#111827",
        color: "#ffffff",
        borderRadius: 999,
        padding: "7px 14px",
        fontSize: 13,
        cursor: "pointer",
      }}
    >
      Got it
    </button>
  </div>
)}

          {picks.length > 0 && <div className = "history2" style={{top: 64, textAlign: "left", fontSize: 14}}>
            <h4 style={{fontSize: 16, textDecoration: 'none', fontWeight: 'normal', margin: '6px 0px'}}>Selected Stocks:</h4>
          {picks.map((pick, index) => (
    <div key={index}>
      <p style={{margin: '4px 0px'}}>{pick.stock.ticker}</p>
    </div>
  ))}</div>}
  <div
  className="history2"
  style={{ bottom: 20, textAlign: "left", fontSize: 14, left: 20, top: "auto" }}
>
  
  <button
    className="actionButton"
    onClick={() => {
      setWlName("Swiping Watchlist");
      setWlError("");
      setWlModalOpen(true);
    }}
  >
    Create a Watchlist
  </button>
    <button
    className="actionButton"
    onClick={handleExportCsv}
  >
    Export as CSV
  </button>
</div>

          <img
            src={exit}
            onClick={handleCloseOverlay}
            className="exitButton"
            alt="Exit"
          />
          <div className="page" style={{height: "100%"}}>
            <div
              className="verticalContent"
              
              ref={card1Ref}
              onPointerDown={(event) => {
                // Mouse pointer capture retargets the eventual click to the card,
                // preventing the desktop left/right navigation zones from firing.
                // Touch and pen still need capture so swiping remains reliable.
                if (event.pointerType !== "mouse") {
                  event.currentTarget.setPointerCapture?.(event.pointerId);
                }
                handleMouseDown(event);
              }}
              onPointerMove={handleMouseMove}
              onPointerUp={handleMouseUp}
              onPointerCancel={handleMouseUp}
              style={{
                position: "relative",
                overflow: "hidden",
                backgroundColor: bgColor,
                color: textColor,
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      border: `3px solid ${darkenColor(bgColor, 0.15)}`, // darker border
                transform: "translateX(${offsetX}px)",
              }}
            >
              {!hasActiveCard && (
                <div className="swipeLoaderOverlay">
                  <div className="loader"></div>
                  <div className="swipeLoaderLabel">Finding your next stock…</div>
                </div>
              )}
              <div className="containerB" style={{ visibility: hasActiveCard ? "visible" : "hidden" }}>
                <div
                  className="itemB"
                  style={{
                    backgroundColor:
                      currentPage === 0 ? textColor : "rgba(171, 159, 171, 0.5)",
                  }}
                ></div>
                <div
                  className="itemB"
                  style={{
                    backgroundColor:
                      currentPage === 1 ? textColor : "rgba(171, 159, 171, 0.5)",
                  }}
                ></div>
                <div
                  className="itemB"
                  style={{
                    backgroundColor:
                      currentPage === 2 ? textColor : "rgba(171, 159, 171, 0.5)",
                  }}
                ></div>
                <div
                  className="itemB"
                  style={{
                    backgroundColor:
                      currentPage === 3 ? textColor : "rgba(171, 159, 171, 0.5)",
                  }}
                ></div>
              </div>
              <div
                className="leftSide"
                style={{ zIndex: 10000, cursor: "pointer", display: hasActiveCard ? "block" : "none" }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleLeft();
                }}
                aria-label="Previous card view"
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") handleLeft();
                }}
              />
              <div
                className="rightSide"
                style={{ zIndex: 10000, cursor: "pointer", display: hasActiveCard ? "block" : "none" }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleRight();
                }}
                aria-label="Next card view"
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") handleRight();
                }}
              />
              <div className="inside" style={{ height: "calc(100% - 16px)", visibility: hasActiveCard ? "visible" : "hidden" }}>
                {stockData.map((stock, index) => (
                  <div
                    key={index}
                    style={{ display: 0 === index ? "block" : "none" }}
                  >
                    <p
                      className="CompName"
                      style={{
      userSelect: "none",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      width: "90%",
      justifyContent: "space-between",
      paddingRight: 20,
      display: "flex", // Ensures all elements stay in one line
      alignItems: "center", // Aligns text and images properly
      gap: "30px", // Adds spacing between text and images
    }}
                    >
                      <div style={{display: "flex", alignItems: "center", gap: 20}}>{stock.symbol} 
                      <div
      style={{
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        
        borderRadius: "10px", // Optional: Rounds the edges
      }}
    >
      <SwipeCompanyLogo src={logo} ticker={stock.symbol} />
    </div></div>
                      
                      <FavoriteStar isFavorite={isFavorite} toggleFavorite={toggleFavorite} color={textColor} swipeCase={true} disabled={favoriteSaving}/>
                    </p>
                    <p className="CompTckr" style={{
                        userSelect: "none",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        width: "90%",
                      }}>
                      {stock.security_name}
                    </p>
                    
                  </div>
                ))}
                {currentPage === 0 && (
                  <>{Boolean(cap) && (
                    <TagPills
    sector={sector}
    industryA={industryA}
    hasETF={hasETF}
    marketCap={cap} // Pass the marketCap prop to TagPills
  />)
  }
                    <p
    className="bio"
    style={{
      userSelect: "none",
      // Set your desired height
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 8, // Limits to 3 lines, adjust as needed
      WebkitBoxOrient: "vertical",
    }}
  >
    {bio}
  </p>

                  </>
                )}

                {currentPage === 1 ? (
                  <div
                    className="chart swipeChartPanel"
                    style={{
                      userSelect: "none",
                      width: "100%",
                      height: "calc(100% - 192px)",
                      marginTop: 12,
                    }}
                  >
                    <div
        style={{
          display: "flex",
          marginLeft: 20,
          gap: 10,
          height: 30,
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
        className="body-RangeSelector mobileRangeSelector"
      >
        {ranges.map((r) => {
    const isActive = range === r; // compare state (range) to the iterated value (r)
    return (
      <div
        key={r}
        onClick={() => setRange(r)}
        className={`range-button ${isActive ? "active" : ""}`}
        style={{
          zIndex: 99999999,
          backgroundColor: isActive
            ? darkenColor(bgColor, 0.25)
            : "transparent",
          color: textColor,
          borderRadius: 6,
          padding: "4px 12px",
          cursor: "pointer",
          transition: "all 0.2s ease",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {r}
      </div>
    );
  })}

      </div>
      {chartData ? (
    <Chart
                                      options={chartData.options}
                                      series={chartData.series}
                                      type={showCandlestick ? "candlestick" : "line"}
                                      height={"100%"}
                                      width={"100%"}
                                    />
  ) : chartError ? (
    <div className="swipeDataEmpty"><strong>Chart unavailable</strong><span>Price history could not be loaded for this range.</span></div>
  ) : (
    <div style={{ padding: 12, opacity: 0.7 }}>Loading chart…</div>
  )}
                    
                  </div>
                ): currentPage === 2 ? (
                  <div className="chart swipeNewsPanel" style={{ userSelect: "none" }}>
      <div className="swipeNewsHeader"><strong>Company news</strong></div>
      <div className="newsList swipeNewsList" style={{ userSelect: "none" }}>
    {(() => {
      // Normalize incoming shapes
      const raw =
        Array.isArray(currentNews?.items) ? currentNews.items :
        Array.isArray(currentNews?.news)  ? currentNews.news  :
        Array.isArray(currentNews)        ? currentNews        : [];

      if (!raw.length) {
        return <div className="swipeDataEmpty"><strong>No recent coverage</strong><span>We could not find current articles for this company.</span></div>;
      }

      // Pick a date field and sort newest → oldest
      const getDate = (it) =>
        it.pubDate || it.published_at || it.date || it.created_at || null;

      const items = raw
        .slice() // don’t mutate original
        .sort((a, b) => {
          const da = dayjs(getDate(a));
          const db = dayjs(getDate(b));
          if (!da.isValid() && !db.isValid()) return 0;
          if (!da.isValid()) return 1;   // undated go last
          if (!db.isValid()) return -1;
          return db.valueOf() - da.valueOf();
        })
        .slice(0, 5);

      return items.map((it, idx) => {
        const source = it.creator || getDomain(it.link) || "Source";
        const when   = getDate(it) ? dayjs(getDate(it)).format("YYYY-MM-DD HH:mm") : "";

        return (
          <a
            key={`${it.link || it.title || idx}-${idx}`}
            href={it.link}
            target="_blank"
            rel="noreferrer"
            className="newsItem"
            onPointerDown={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.stopPropagation()}
            onClick={(event) => event.stopPropagation()}
            style={{
              display: "block",
              color: textColor,
              textDecoration: "none",
              fontFamily: "Poppins",
              border: `1px solid ${darkenColor(bgColor, 0.13)}`,
              background: "rgba(255,255,255,.075)",
            }}
          >
            <div className="swipeNewsMeta">
              <span>{source}</span>
              {when && <span>• {when}</span>}
            </div>

            <div className="swipeNewsTitle">
              {it.title}
            </div>

            {it.description && (
              <div className="swipeNewsDescription">
                {truncate(it.description, 200)}
              </div>
            )}
          </a>
        );
      });
    })()}
  </div>
    </div>
                ) : currentPage === 3 ? (
                  <div
                    className="chart"
                    style={{
                      userSelect: "none",
                      width: "100%",
                      height: "100%",
                      padding: "6px 10px 10px",
                      boxSizing: "border-box",
                    }}
                  >
    {(() => {
      const pe = getMetric(currentRatios, ["basicMetrics.priceToEarnings", "Ratios.PE", "Ratios.pe"]);
      const ps = getMetric(currentRatios, ["basicMetrics.priceToSales", "Ratios.PS", "Ratios.ps"]);
      const pb = getMetric(currentRatios, ["basicMetrics.priceToBooks", "Ratios.PB", "Ratios.pb"]);
      const evRevenue = getMetric(currentRatios, ["Ratios.evtoRevenue", "Ratios.evToRevenue", "basicMetrics.evToRevenue"]);
      const evEbitda = getMetric(currentRatios, ["Ratios.evtoebitda", "Ratios.evToEbitda", "basicMetrics.evToEbitda"]);
      const graham = getMetric(currentRatios, ["basicMetrics.grahamNumber", "Ratios.grahamNumber"]);
      const roe = getMetric(currentRatios, ["Ratios.ROE", "basicMetrics.ROE"]);
      const roa = getMetric(currentRatios, ["Ratios.ROA", "basicMetrics.ROA"]);
      const roic = getMetric(currentRatios, ["Ratios.ROIC", "basicMetrics.ROIC"]);
      const grossMargin = getMetric(currentRatios, ["basicMetrics.GrossMargin", "Ratios.GrossMargin"]);
      const currentRatio = getMetric(currentRatios, ["Ratios.CurrentRatio", "basicMetrics.currentRatio"]);
      const debtEquity = getMetric(currentRatios, ["Ratios.debtToequity", "Ratios.debtToEquity", "basicMetrics.debtToEquity"]);
      const beta = getMetric(currentRatios, ["Ratios.beta", "basicMetrics.beta"]);
      const netMargin = getMetric(currentRatios, ["basicMetrics.netMargin", "Ratios.netMargin"]);
      const operatingMargin = getMetric(currentRatios, ["basicMetrics.operatingMargin", "Ratios.operatingMargin"]);
      const quickRatio = getMetric(currentRatios, ["Ratios.quickRatio", "basicMetrics.quickRatio"]);
      const interestCoverage = getMetric(currentRatios, ["Ratios.interestCoverage", "basicMetrics.interestCoverage"]);
      const altman = getMetric(currentRatios, ["Bankruptcy.AltmanZScore", "Bankruptcy.Altman2ZScore"]);
      const dividendYield = getMetric(currentRatios, ["basicMetrics.dividendYield", "Ratios.dividendYield"]);
      const revenueGrowth = getMetric(currentRatios, ["basicMetrics.revenueGrowth", "Ratios.revenueGrowth"]);
      const fundamentalsMarketCap = getMetric(currentRatios, ["basicMetrics.marketCap", "basicMetrics.cap2", "Ratios.marketCap"]);
      // Swipe/scanner queue marketCap values are stored in USD millions.
      // Fundamentals market cap, when present, is already expressed in raw USD.
      const marketCapValue = Number.isFinite(fundamentalsMarketCap) && fundamentalsMarketCap > 0
        ? (fundamentalsMarketCap >= 10_000_000 ? fundamentalsMarketCap : fundamentalsMarketCap * 1_000_000)
        : Number(cap) > 0 ? Number(cap) * 1_000_000 : null;

      const sections = [
        {
          title: "Overview",
          items: [
            { label: "Market cap", value: formatCompactCurrency(marketCapValue), raw: marketCapValue },
            { label: "Beta", value: formatNum(beta), raw: beta },
            { label: "Dividend yield", value: formatPercent(dividendYield), raw: dividendYield },
          ],
        },
        {
          title: "Valuation",
          items: [
            { label: "P/E", value: formatNum(pe), raw: pe },
            { label: "P/S", value: formatNum(ps), raw: ps },
            { label: "P/B", value: formatNum(pb), raw: pb },
            { label: "EV / sales", value: formatNum(evRevenue), raw: evRevenue },
            { label: "EV/EBITDA", value: formatNum(evEbitda), raw: evEbitda },
            { label: "Graham value", value: formatNum(graham), raw: graham },
          ],
        },
        {
          title: "Profitability",
          items: [
            { label: "ROE", value: formatPercent(roe), raw: roe, meter: true },
            { label: "ROA", value: formatPercent(roa), raw: roa, meter: true },
            { label: "ROIC", value: formatPercent(roic), raw: roic, meter: true },
            { label: "Gross margin", value: formatPercent(grossMargin, 1, true), raw: Number.isFinite(grossMargin) ? grossMargin / 100 : null, meter: true },
            { label: "Net margin", value: formatPercent(netMargin, 1, true), raw: Number.isFinite(netMargin) ? netMargin / 100 : null, meter: true },
            { label: "Operating margin", value: formatPercent(operatingMargin, 1, true), raw: Number.isFinite(operatingMargin) ? operatingMargin / 100 : null, meter: true },
          ],
        },
        {
          title: "Financial profile",
          items: [
            { label: "Current ratio", value: formatNum(currentRatio), raw: currentRatio },
            { label: "Quick ratio", value: formatNum(quickRatio), raw: quickRatio },
            { label: "Debt / equity", value: formatNum(debtEquity), raw: debtEquity },
            { label: "Interest cover", value: formatNum(interestCoverage), raw: interestCoverage },
            { label: "Altman Z", value: formatNum(altman), raw: altman },
            { label: "Revenue growth", value: formatPercent(revenueGrowth), raw: revenueGrowth },
          ],
        },
      ];

      const allSnapshotItems = sections.flatMap((section) => section.items);
      const availableSignals = allSnapshotItems.filter((item) => Number.isFinite(item.raw)).length;

      return (
        <div
          className="swipeSnapshot"
        >
          <div className="swipeSnapshotHeader">
            <div><span>Quick research</span><strong>Company snapshot</strong></div>
            <span>{availableSignals}/{allSnapshotItems.length} signals</span>
          </div>
          {!availableSignals ? <div className="swipeDataEmpty"><strong>Fundamentals unavailable</strong><span>We do not have enough financial data to build this snapshot yet.</span></div> : null}
          {availableSignals ? sections.map(section => (
            <div key={section.title} className="swipeSnapshotSection">
              <div className="swipeSnapshotSectionTitle" style={{ color: textColor }}>
                {section.title}
              </div>

              <div className="swipeSnapshotGrid">
                {section.items.map(t => (
                  <div
                    key={`${section.title}-${t.label}`}
                    className={`swipeSnapshotMetric ${Number.isFinite(t.raw) ? "" : "swipeSnapshotMetric--missing"}`}
                    style={{
                      border: `1px solid ${darkenColor(bgColor, 0.14)}`,
                      borderRadius: 9,
                      padding: "8px 9px",
                      color: textColor,
                      background: "rgba(255,255,255,0.06)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 9.5,
                        opacity: 0.72,
                        lineHeight: 1.2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {t.label}
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: 1.15,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {t.value}
                    </div>
                    {t.meter && <div className="swipeMetricTrack"><span style={{ width: Number.isFinite(t.raw) ? `${Math.max(3, Math.min(100, Math.abs(t.raw) * 250))}%` : "0%" }} /></div>}
                    {!Number.isFinite(t.raw) && <span className="swipeMissingLabel">No data</span>}
                  </div>
                ))}
              </div>
            </div>
          )) : null}
        </div>
      );
    })()}
  </div>
                ) : null}
              </div>

              <div
                style={{
                  position: "absolute",
                  left: "50%",
                  bottom: 18,
                  transform: "translateX(-50%)",
                  display: "flex",
                  alignItems: "center",
                  gap: 18,
                  zIndex: 20000,
                  visibility: hasActiveCard ? "visible" : "hidden",
                  pointerEvents: hasActiveCard ? "auto" : "none",
                }}
                onMouseDown={(e) => e.stopPropagation()}
                onMouseUp={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="swipeControlButton swipeControlButton--left"
                  aria-label="Pass stock"
                  title="Pass"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSwipeButton("left");
                  }}
                >
                  <svg className="swipeControlIcon" viewBox="0 0 32 32" aria-hidden="true">
                    <path d="M18.5 7.5 10 16l8.5 8.5M10.8 16H26" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

                <button
                  type="button"
                  className="swipeControlButton swipeControlButton--favorite"
                  aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
                  title={isFavorite ? "Remove from favorites" : "Add to favorites"}
                  disabled={favoriteSaving}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite();
                  }}
                >
                  <svg className="swipeControlIcon swipeControlIcon--star" viewBox="0 0 32 32" aria-hidden="true">
                    <path d="m16 4.2 3.55 7.2 7.95 1.15-5.75 5.6 1.36 7.91L16 22.32l-7.11 3.74 1.36-7.91-5.75-5.6 7.95-1.15L16 4.2Z" fill="currentColor" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
                  </svg>
                </button>

                <button
                  type="button"
                  className="swipeControlButton swipeControlButton--right"
                  aria-label="Select stock"
                  title="Select"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSwipeButton("right");
                  }}
                >
                  <svg className="swipeControlIcon" viewBox="0 0 32 32" aria-hidden="true">
                    <path d="M13.5 7.5 22 16l-8.5 8.5M21.2 16H6" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
            {/* Second card positioned behind the first one 
            
            
            
              backgroundImage: `url(${imageSrc})`,*/
            }
            <div
              className="verticalContent"
              ref={card2Ref}
              style={{
                backgroundColor: nextBgColor,
                position: "absolute",
                color: nextTextColor,
                top: 20,
                bottom: 20,
                height: "calc(100% - 40px)", 
                    border: `3px solid ${darkenColor(nextBgColor, 0.15)}`, // darker border

                zIndex: -1,
              }}
            >
              <div className="containerB">
                <div
                  className="itemB"
                  style={{ backgroundColor: nextTextColor }}
                ></div>
                <div
                  className="itemB"
                  style={{ backgroundColor: "rgba(171, 159, 171, 0.5)" }}
                ></div>
                <div
                  className="itemB"
                  style={{ backgroundColor: "rgba(171, 159, 171, 0.5)" }}
                ></div>
                <div
                  className="itemB"
                  style={{ backgroundColor: "rgba(171, 159, 171, 0.5)" }}
                ></div>
              </div>
              <div className="inside">
                {stockData.map((stock, index) => (
                  <div
                    key={index}
                    style={{ display: 1 === index ? "block" : "none" }}
                  >
                    <p
                      className="CompName"
                      style={{
      userSelect: "none",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      width: "90%",
      display: "flex", // Ensures all elements stay in one line
      alignItems: "center", // Aligns text and images properly
      gap: "30px", // Adds spacing between text and images
    }}
                    >
                      {stock.symbol}<div
      style={{
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        
        borderRadius: "10px", // Optional: Rounds the edges
      }}
    >
      <SwipeCompanyLogo src={nextLogo} ticker={stock.symbol} />
    </div>
                    </p>
                    <p className="CompTckr" style={{
                        userSelect: "none",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        width: "90%",
                      }}>
                      {stock.security_name}
                    </p>
                  </div>
                ))}

  <TagPills
    sector={Nextsector}
    industryA={Nextindustry}
    hasETF={nextHasETF}
    marketCap={nextCap} 
  />
                <p
    className="bio"
    style={{
      userSelect: "none",
      // Set your desired height
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 8, // Limits to 3 lines, adjust as needed
      WebkitBoxOrient: "vertical",
    }}
  >
    {nextBio} 
  </p>
              </div>
            </div>
          </div>
          {wlModalOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      zIndex: 999999,
      display: "flex",
      width: "calc(100% - var(--sidebar-width, 306px))",
      alignItems: "center",
      justifyContent: "center",
    }}
    onClick={() => setWlModalOpen(false)} // click on dark overlay closes
  >
    <div
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking card
      style={{
        background: "#ffffff",
        borderRadius: 16,
        padding: "20px 24px 18px",
        width: "100%",
        maxWidth: 360,
        boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
        fontFamily: "Poppins, system-ui, -apple-system, BlinkMacSystemFont",
      }}
    >
      <div
        style={{
          fontSize: 16,
          fontWeight: 600,
          marginBottom: 6,
          textAlign: "left",
        }}
      >
        Create watchlist
      </div>
      <p
        style={{
          fontSize: 12,
          color: "#6b7280",
          marginTop: 0,
          marginBottom: 14,
          textAlign: "left",
        }}
      >
        Name this list. Your selected stocks from this swiping session will be added.
      </p>

      <form onSubmit={handleCreateWatchlistSubmit}>
        <div style={{ marginBottom: 12 }}>
          <input
            autoFocus
            value={wlName}
            onChange={(e) => setWlName(e.target.value)}
            placeholder="Swiping Watchlist"
            style={{
              width: "100%",
              border: "none",
              borderBottom: "1px solid #e5e7eb",
              outline: "none",
              padding: "6px 0 8px",
              fontSize: 14,
            }}
          />
        </div>

        {wlError && (
          <div
            style={{
              color: "#dc2626",
              fontSize: 12,
              marginBottom: 8,
              textAlign: "left",
            }}
          >
            {wlError}
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 4,
          }}
        >
          <button
            type="button"
            onClick={() => setWlModalOpen(false)}
            style={{
              border: "none",
              background: "transparent",
              fontSize: 13,
              padding: "6px 10px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={wlSaving}
            style={{
              border: "none",
              background: "#111827",
              color: "#ffffff",
              borderRadius: 999,
              padding: "6px 14px",
              fontSize: 13,
              cursor: wlSaving ? "default" : "pointer",
              opacity: wlSaving ? 0.7 : 1,
            }}
          >
            {wlSaving ? "Creating…" : "Create"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

        </div>
      
    );
  };

  export default Swiping;
